import { Component, Input, Output, EventEmitter } from '@angular/core';
import { PartieDepot } from '../../../../../entities/requete';
import { RequerantsHandlingError } from '../add-requerant-section.component';


@Component({
    selector: 'jhi-result-form',
    templateUrl: './result-form.component.html',
    styleUrls: [
        'result-form.component.scss'
    ]
})
export class ResultFormComponent {

    @Input()
    requerant: PartieDepot;

    @Input() errorType: RequerantsHandlingError;

    RequerantsHandlingErrorEnum = RequerantsHandlingError;

    @Output() onAddRequerant = new EventEmitter<any>();
    addRequerant() {
        this.onAddRequerant.emit();
    }

    constructor() {
    }

}



// WEBPACK FOOTER //
// ./src/main/webapp/app/depot-requete/steps/requerants/add-requerant-section/result-form/result-form.component.ts